import React from "react";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    wrapper: {
        width: "24px",
        height: "auto"
    },
    inactiveColor: {
        fill: theme.app.labelColor,
    },
    activeColor: {
        fill: theme.palette.primary.main
    }
}))
const CoursesIcon = ({active}) => {
    const classes = useStyles()
    return (
        <div className={classes.wrapper}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="256"
            height="256"
            viewBox="0 0 256 256"
            style={{width: "20px", height: "auto"}}
        >
            <g strokeMiterlimit="10" strokeWidth="1" className={active ? classes.activeColor : classes.inactiveColor}>
                <path
                    d="M67.776 56.318a2.546 2.546 0 00-.155-.365L46.349 15.176a8.791 8.791 0 00-7.828-4.753H11.887c-4.249 0-7.705 3.456-7.705 7.705v3.044c0 4.249 3.456 7.705 7.705 7.705h17.93c.742 0 1.417.409 1.761 1.067l4.148 7.94-20.609 11.197a2.499 2.499 0 00-.647 3.889c4.531 4.927 8.792 7.379 13.029 7.496.105.003.21.005.315.005 3.547 0 7.054-1.662 10.405-4.924 4.689-4.44 8.872-4.441 13.561 0 5.863 5.554 11.127 5.188 14.513 3.902a2.502 2.502 0 001.483-3.131zM74.782 13.402c-7.726 0-14.011 6.285-14.011 14.01 0 7.726 6.285 14.011 14.011 14.011s14.011-6.285 14.011-14.011c0-7.724-6.285-14.01-14.011-14.01z"
                    transform="matrix(2.81 0 0 2.81 1.407 1.407)"
                ></path>
                <path
                    d="M89.22 65.917c-6.592-6.242-13.85-6.243-20.439.001-4.689 4.441-8.871 4.442-13.561-.001-6.592-6.242-13.849-6.242-20.439.001-4.688 4.443-8.872 4.443-13.561 0-6.59-6.244-13.849-6.244-20.438 0A2.494 2.494 0 000 67.732v10a2.502 2.502 0 004.219 1.815c4.69-4.44 8.873-4.441 13.561 0C21.076 82.67 24.538 84.23 28 84.23c3.462 0 6.925-1.562 10.219-4.684 4.69-4.44 8.874-4.441 13.561 0 6.59 6.244 13.848 6.243 20.439.001 4.689-4.443 8.871-4.443 13.561 0A2.501 2.501 0 0090 77.732v-10c0-.686-.282-1.342-.78-1.815z"
                    transform="matrix(2.81 0 0 2.81 1.407 1.407)"
                ></path>
            </g>
        </svg>
        </div>
    );
}

export default CoursesIcon;
